import { gql } from "@apollo/client";

// this to get social media sellers without filter

export const globalStoresByCatName = gql`
  query globalStoresByCatName(
    $filterOptions: StoreFiltersInput
    $page: Int = 1
    $itemsPerPage: Int = 8
    $sort: [String]
  ) {
    stores(
      filters: $filterOptions
      pagination: { pageSize: $itemsPerPage, page: $page }
      sort: $sort
    ) {
      meta {
        pagination {
          total
        }
      }
      data {
        id
        attributes {
          deletedAt
          deleted
          slug
          name
          sub_category {
            data {
              attributes {
                name
              }
            }
          }
          client_reviews {
            data {
              attributes {
                general_review
                customer_service_review
                product_image_review
              }
            }
          }

          mainImage {
            data {
              attributes {
                url
              }
            }
          }
          productImageNames {
            data {
              attributes {
                url
                formats
              }
            }
          }
          platformActivity
          responseReaction
          hasDelivery
          likesNbr
          platform
          reviewRate
          website
          url
        }
      }
    }
  }
`;
export const globalSearch = gql`
  query globalSearch(
    $filterOptions: StoreFiltersInput
    $keyword: String!
    $page: Int = 1
    $itemsPerPage: Int = 8
    $sort: [String]
  ) {
    search(query: $keyword) {
      stores(
        filters: $filterOptions
        pagination: { pageSize: $itemsPerPage, page: $page }
        sort: $sort
      ) {
        meta {
          pagination {
            total
          }
        }
        data {
          id
          attributes {
            deletedAt
            deleted
            name
            slug
            sub_category {
              data {
                attributes {
                  name
                  category {
                    data {
                      attributes {
                        slug
                      }
                    }
                  }
                }
              }
            }
            mainImage {
              data {
                attributes {
                  url
                }
              }
            }
            productImageNames {
              data {
                attributes {
                  url
                  formats
                }
              }
            }
            platformActivity
            responseReaction
            hasDelivery
            likesNbr
            platform
            reviewRate
            website
            url
          }
        }
      }
    }
  }
`;

export const getStoreBySlug = gql`
  query getStore($slug: String!) {
    stores(filters: { slug: { eq: $slug } }) {
      data {
        id
        attributes {
          name_logo_changes
          deletedAt
          deleted
          description
          isNoIndex
          sub_category {
            data {
              attributes {
                category {
                  data {
                    attributes {
                      name
                      slug
                    }
                  }
                }
                name
              }
            }
          }
          otherAddresses
          slug
          plan
          mainImage {
            data {
              attributes {
                url
              }
            }
          }

          name
          hasDelivery
          platformActivity
          likesNbr
          url
          responseReaction
          phone
          website
          reviewRate
          State
          country
          latitude
          longitude
          productImageNames {
            data {
              id
              attributes {
                name
                url
              }
            }
          }
          updatedAt
        }
      }
    }
  }
`;
export const getStoreById = gql`
  query Stores($filters: StoreFiltersInput) {
    stores(filters: $filters) {
      data {
        attributes {
          sub_category {
            data {
              attributes {
                category {
                  data {
                    attributes {
                      slug
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const getAffariyetCheck = gql`
  query Affariyets($filters: AffariyetFiltersInput) {
    affariyets(filters: $filters) {
      data {
        attributes {
          store {
            data {
              attributes {
                slug
                sub_category {
                  data {
                    attributes {
                      category {
                        data {
                          attributes {
                            slug
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const getAffariyets = gql`
  query affariyets($filters: AffariyetFiltersInput, $pagination: PaginationArg) {
    affariyets(filters: $filters, pagination: $pagination) {
      data {
        attributes {
          url
          store {
            data {
              attributes {
                url
                slug
                name
                sub_category {
                  data {
                    attributes {
                      name
                      category {
                        data {
                          id
                          attributes {
                            slug
                            name
                          }
                        }
                      }
                    }
                  }
                }
                mainImage {
                  data {
                    attributes {
                      name
                      url
                    }
                  }
                }
                slug
              }
              id
            }
          }
          image {
            data {
              attributes {
                name
                url
              }
            }
          }
          expires_at
          createdAt
        }
      }
      meta {
        pagination {
          total
          page
          pageCount
        }
      }
    }
  }
`;

export const getStoreReview = gql`
  query client_review($filters: ClientReviewFiltersInput) {
    clientReviews(filters: $filters) {
      data {
        id
        attributes {
          customer_service_review
          product_image_review
        }
      }
    }
  }
`;

export const getStoreComments = gql`
  query getComments(
    $filters: CommentFiltersInput
    $pagination: PaginationArg
    $sort: [String]
    $publicationState: PublicationState
  ) {
    comments(
      filters: $filters
      pagination: $pagination
      sort: $sort
      publicationState: $publicationState
    ) {
      meta {
        pagination {
          total
          page
          pageSize
          pageCount
        }
      }
      data {
        id
        attributes {
          users_permissions_user {
            data {
              attributes {
                username
                user_profile {
                  data {
                    attributes {
                      full_name
                      picture {
                        data {
                          attributes {
                            url
                          }
                        }
                      }
                    }
                  }
                }
                user_profile {
                  data {
                    attributes {
                      full_name
                    }
                  }
                }
              }
            }
          }
          text
          createdAt
          comment_image {
            data {
              attributes {
                url
                name
                height
                width
              }
            }
          }
          image {
            data {
              attributes {
                url
              }
            }
          }
        }
      }
    }
  }
`;

export const getAllStoreSlugs = gql`
  query getStore($itemsPerPage: Int = 10, $page: Int = 1) {
    stores(filters: { slug: { ne: null } }, pagination: { pageSize: $itemsPerPage, page: $page }) {
      meta {
        pagination {
          total
        }
      }
      data {
        id
        attributes {
          slug
          sub_category {
            data {
              attributes {
                name
                category {
                  data {
                    attributes {
                      slug
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getStoreSocialStores = gql`
  query StoreSocial($filters: StoreFiltersInput) {
    stores(filters: $filters) {
      data {
        id
        attributes {
          fb_store {
            data {
              id
            }
          }
          insta_store {
            data {
              id
            }
          }
        }
      }
    }
  }
`;

export const getGoogleCommentsByStoreId = gql`
  query GoogleReviews($filters: GoogleReviewFiltersInput) {
    googleReviews(filters: $filters) {
      data {
        id
        attributes {
          author_name
          language
          profile_photo_url
          rating
          text
          createdAt
        }
      }
    }
  }
`;

export const getPopularAffariyetBySubCategory = gql`
  query PopularOffers($filters: PopularOfferFiltersInput) {
    popularOffers(filters: $filters) {
      data {
        attributes {
          affariyets {
            data {
              attributes {
                image {
                  data {
                    attributes {
                      name
                      url
                    }
                  }
                }
                store {
                  data {
                    attributes {
                      name
                      mainImage {
                        data {
                          attributes {
                            name
                            url
                          }
                        }
                      }
                      slug
                      sub_category {
                        data {
                          attributes {
                            category {
                              data {
                                attributes {
                                  slug
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getSimilarStoresBySubCategory = gql`
  query SimilarStores($filters: SimilarStoreFiltersInput) {
    similarStores(filters: $filters) {
      data {
        attributes {
          sub_category {
            data {
              attributes {
                slug
              }
            }
          }
          stores {
            data {
              attributes {
                name
                hasDelivery
                likesNbr
                slug
                platform
                reviewRate
                mainImage {
                  data {
                    attributes {
                      name
                      url
                    }
                  }
                }
                productImageNames {
                  data {
                    attributes {
                      name
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
